var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ligneTitre"},[_vm._t("default"),_c('div',{staticClass:"righticons"},[_c('img',{attrs:{"src":"/assets/icons/liste.png"},on:{"click":_vm.listMode}}),_c('img',{attrs:{"src":"/assets/icons/mosaic.png"},on:{"click":_vm.mosaicMode}}),_vm._t("reload")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }